import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/graphTag/page',
  ADD: '/dh-datamaint/graphTag/add',
  DELETE: '/dh-datamaint/graphTag/delete',
  DETAIL: '/dh-datamaint/graphTag/getById',
  UPDATE: '/dh-datamaint/graphTag/update',
  SORT: '/dh-datamaint/graphTag/sort',
  GET_SORT: '/dh-datamaint/graphTag/count',
  RELATION_PAGE: '/dh-datamaint/graphTag/relation/page',
  RELATION_ADD: '/dh-datamaint/graphTag/relation/add',
  RELATION_DETAIL: '/dh-datamaint/graphTag/relation/getById',
  RELATION_UPDATE: '/dh-datamaint/graphTag/relation/update',
  RELATION_DELETE: '/dh-datamaint/graphTag/relation/delete',
  RELATION_SAVE_LIST: '/dh-datamaint/graphTag/relation/save',
  RELATION_SORT: '/dh-datamaint/graphTag/relation/sort',
  RELATION_GET_SORT: '/dh-datamaint/graphTag/relation/count'
};

class GraphTagModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE, { params: payload.data });
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async Sort(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SORT, payload.data);
    },

    async getSort(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_SORT, { params: payload.data });
    },

    async getRelationPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.RELATION_PAGE, { params: payload.data });
    },

    async addRelation(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.RELATION_ADD, payload.data);
    },

    async getRelationDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.RELATION_DETAIL, { params: payload.data });
    },

    async UpdateRelation(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.RELATION_UPDATE, payload.data);
    },

    async DeleteRelation(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.RELATION_DELETE, null, { params: payload.data });
    },

    async saveRelationList(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.RELATION_SAVE_LIST, payload.data);
    },

    async RelationSort(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.RELATION_SORT, payload.data);
    },

    async getRelationSort(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.RELATION_GET_SORT, { params: payload.data });
    }
  };
}

export const graphTagModule = new GraphTagModule();
